
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getAll() {
        const url = `${API_URL}/tallas`; 
        return axios.get(url, { headers: authHeader() });
    },
    getData(id) {
        return axios.get(`${API_URL}/tallas/${id}`, { headers: authHeader() });
    },
    createData(data) {
        return axios.post(`${API_URL}/tallas`, data, { headers: authHeader() });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/tallas/${id}`, data, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/tallas/${id}`, { headers: authHeader() });
    },
    
};